export default __webpack_public_path__ + "static/media/chevron-down-tc_blue.85907a5f.svg";